var _rect, _path, _path2, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDatasetSelectionIcon = function SvgDatasetSelectionIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 39.5L104 22L130.5 58",
    stroke: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 28.125V31.5C52.25 34.6078 45.1977 37.125 36.5 37.125C27.8023 37.125 20.75 34.6078 20.75 31.5V28.125C20.75 25.0172 27.8023 22.5 36.5 22.5C45.1977 22.5 52.25 25.0172 52.25 28.125ZM48.3969 37.5961C49.8594 37.0758 51.2023 36.4078 52.25 35.5852V42.75C52.25 45.8578 45.1977 48.375 36.5 48.375C27.8023 48.375 20.75 45.8578 20.75 42.75V35.5852C21.7977 36.4148 23.1406 37.0758 24.6031 37.5961C27.7602 38.7211 31.9648 39.375 36.5 39.375C41.0352 39.375 45.2398 38.7211 48.3969 37.5961ZM20.75 46.8352C21.7977 47.6648 23.1406 48.3258 24.6031 48.8461C27.7602 49.9711 31.9648 50.625 36.5 50.625C41.0352 50.625 45.2398 49.9711 48.3969 48.8461C49.8594 48.3258 51.2023 47.6578 52.25 46.8352V52.875C52.25 55.9828 45.1977 58.5 36.5 58.5C27.8023 58.5 20.75 55.9828 20.75 52.875V46.8352Z",
    fill: "#929292"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 40,
    r: 4,
    fill: "#8F8F8F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 22,
    r: 4,
    fill: "#8F8F8F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 59,
    r: 4,
    fill: "#8F8F8F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDatasetSelectionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataset-selection-icon.d19164154dcff279a1bd5f8b102bd821.svg";